<template>
    <div id="unshowselect">
        <el-select style="position: absolute;" ref="theselect" automatic-dropdown v-bind:style="selectwidth" v-model="selects" @visible-change="initial" @change="changeselects" multiple collapse-tags placeholder="">
            <el-option v-for="item in fields" :key="item.name" :label="item.title" :value="item.name">
            </el-option>
        </el-select>

        <el-tag v-show="unshowfields.tag" :closable="true"
        size="medium"
         @click="openselect()"
         @close="handleClose()" type="danger">{{ unshowfields.tag }}
        </el-tag>
        
        <el-tag v-show="!unshowfields.tag" :closable="false" type="success"
        @click="openselect()">Show
        </el-tag>

    </div>
</template>

<style>
#unshowselect .el-select .el-select__tags {display:none}
#unshowselect .el-select .el-input__icon {display:none}
</style>

<script>
import { fieldsprocess } from "zxg-table-fieldsprocess";




export default {
    mounted(){


    },
    data() {
        return {
            selectwidth:this.selectwidth={zIndex:-100,width:"200px", marginLeft:"-200px",top:"20px"},
            selects: [],

        }
    },
    computed: {
        fields:function(){
            let configurablefields=[]
            let fields=fieldsprocess(this.$store.state.currentheader, "table",this.$store)
            //只有header中那些本来未被设置为false或者通过localset的field才能够被前端设置
            fields.forEach(fieldobj => {
                if (fieldobj.visible != false || fieldobj.localset) {
                    configurablefields.push(fieldobj)
                }
            })

            return configurablefields
        },
        unshowfields: function () {
            return this.$store.state.unshowfields
        },

    },

    methods: {
        openselect(){
            
            this.$refs.theselect.focus()
        },
        initial(){
 
            //如果在unshowfields中设置了，那么按照设置的选择
            let unshowfields=this.$store.state.unshowfields //
            if(unshowfields.fieldsset && unshowfields.fieldsset.shows && unshowfields.fieldsset.shows.length>0 ){
                

                    this.selects=unshowfields.fieldsset.shows
 
            }
            else{
                let initialselects=[]
                this.fields.forEach(obj=>{
                    initialselects.push(obj.name)
                })
                this.selects=initialselects
            }
        },
        changeselects() {
            let unshowfields = { tag: "Show", fieldsset: {shows:this.selects} }
     
            this.$store.commit("setunshowfields", unshowfields)
        },
        handleClose() {

            this.$store.commit("setunshowfields", {})
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/presentation/table/unshowfields.vue